import { useState, useEffect } from "react";
import {
  // section,
  filterPrimaries,
  // sortPrimaries,
} from "../helperFunctions/sortAndFilterFunctions";

export const useGlobalSearchData = (
  primaries1 = [],
  primaries2 = [],
  options,
  isSearching = false
) => {
  const [globalData, setGlobalData] = useState([]);

  useEffect(() => {
    if (isSearching) {
      const flattendedData = [primaries1, primaries2].flat();
      let filteredGlobalData = filterPrimaries(flattendedData, options);
      setGlobalData(filteredGlobalData);
    } else {
      setGlobalData([]);
    }
  }, [options, primaries1, primaries2]);

  // console.log("updating sectioned", sectionedTimesheets);
  return globalData;
};
